import { Alert, Card, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';
import Loading from '../../components/loading';
import { usePublicAppointmentConfirmation } from '../hooks/usePublicAppointmentConfirmation';

export default function AppointmentConfirmation() {
  const [searchParams] = useSearchParams();

  const token = useMemo(() => {
    const t = searchParams.get('token');
    return t && t.trim().length > 0 ? t.trim() : null;
  }, [searchParams]);

  const { status, isLoading } = usePublicAppointmentConfirmation(token);

  return (
    <>
      <Loading isToHidden={!isLoading} />

      {status === 'CONFIRMED' ? (
        <Alert severity="success" sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Consulta confirmada com sucesso
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Você pode fechar esta página.
          </Typography>
        </Alert>
      ) : (
        <></>
      )}

      {status === 'ERROR' ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Erro ao confirmar Consulta
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Tente novamente dentro de alguns instantes.
          </Typography>
        </Alert>
      ) : (
        <></>
      )}
    </>
  );
}
